import React from 'react'
import withStyles from '@mui/styles/withStyles'
import { Chip } from '@mui/material'
import TitleHeader from '../../../../../../smallComponents/Header'
import i18next from 'i18next'

const styles = () => ({
  wrapper: {
    fontSize: 15,
    fontWeight: 500,
    padding: 10,
    margin: 10,
    borderRadius: 10,
    background: 'rgba(217,224,252, 0.1)',
    fontStyle: 'oblique',
  },
})

const AspectTags = ({ DCGProps, aspect, classes }) => {
  const { isDarkModeActive } = DCGProps
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <>
      <TitleHeader
        headerText={rtl ? 'مختصرات الجانب' : 'Aspect Tags'}
        subHeaderText={
          rtl ? 'تعرّف على الجانب سريعا' : 'Quickly Identify the Aspect'
        }
      />
      <article className={classes.wrapper}>
        <section
          style={{ display: 'flex', flexFlow: 'row wrap', width: '100%' }}
        >
          {aspect?.tags?.map((tag, idnex) => (
            <Chip
              key={idnex}
              label={tag}
              style={{
                color: isDarkModeActive ? 'white' : null,
                fontSize: 12,
                margin: '2px',
              }}
            />
          ))}
        </section>
      </article>
    </>
  )
}

const WrappedAspectTags = withStyles(styles)(AspectTags)

export default WrappedAspectTags
